//@desc Used as High Order debounced function
function useDebounce(callback, timeout = 800) {
	let timer = null;
	return (...args) => {
		// Clears if there's other timeout running
		clearTimeout(timer);
		timer = setTimeout(() => {
			callback.apply(this, args); // Sends all arguments added
			timer = null;
		}, timeout);
	};
}

export default useDebounce;
